module.exports = {
  schema: {
    name: '供應商資料',
    type: 'Object',
    contents: {
      ragicId: {
        name: 'Ragic Id',
        type: 'Number',
        ragicId: '_ragicId',
        disabled: true,
      },
      key: {
        ragicId: '1000070',
        type: 'String',
        name: '代碼',
        unique: true,
      },
      name: {
        type: 'String',
        name: '供應商編號',
        ragicId: '1000001',
      },
      alias: {
        type: 'String',
        name: '供應商別名(新舊資料轉換階段)',
      },
      organize: {
        ragicId: '1000476',
        type: 'String',
        name: '組織類別',
        disabled: true,
      },
      supplierName: {
        ragicId: '1000135',
        type: 'String',
        name: '供應商名稱',
      },
      shortName: {
        ragicId: '1000002',
        type: 'String',
        name: '供應商簡稱',
      },
      owner: {
        ragicId: '1000009',
        type: 'String',
        name: '負責人',
      },
      CID: {
        ragicId: '1000005',
        type: 'String',
        name: '統一編號',
      },
      contact: {
        ragicId: '1000048',
        type: 'String',
        name: '聯絡人',
      },
      phone: {
        ragicId: '1000006',
        type: 'String',
        name: '供應商電話',
      },
      phone2: {
        ragicId: '1000134',
        type: 'String',
        name: '備用電話',
      },
      FAX: {
        ragicId: '1000007',
        type: 'String',
        name: '供應商傳真',
      },
      address: {
        ragicId: '1000008',
        type: 'String',
        name: '供應商地址',
      },
      storageMA: {
        ragicId: '1000472',
        type: 'String',
        name: '庫存管理',
        options: ['執行', '不執行'],
        input: 'select',
      },
      productCAT: {
        type: 'Array',
        ragicId: '1000103',
        name: '商品類別',
        input: 'select',
        // multi: true,
        contents: [{
          options: ['A', 'B', 'C', 'D', 'E'],
          type: 'String',
          name: 'options-element',
        }],
      },
      status: {
        ragicId: '1000061',
        type: 'String',
        name: '供應商狀態',
        options: ['啟用', ''],
        input: 'select',
      },
      supplyType: {
        ragicId: '1000102',
        type: 'String',
        name: '供應商品',
      },
      paymentMethod: {
        ragicId: '1000052',
        type: 'String',
        name: '付款方式',
        options: ['月結'],
        input: 'select',
      },
      netDays: {
        ragicId: '1000053',
        type: 'String',
        name: '付款天數',
      },
      prepaidBalance: {
        ragicId: '1000054',
        type: 'String',
        name: '預付款餘額',
      },
      isContractor: {
        ragicId: '1000055',
        type: 'String',
        name: '是否為簽約商',
        options: ['否', '是'],
        input: 'select',
      },
      note: {
        ragicId: '1000017',
        type: 'String',
        name: '備註',
      },
      ragicStoreNodeId: {
        type: 'Number',
        name: 'Ragic門市資料Id',
        noclone: true,
      },
      ragicCenterNodeId: {
        type: 'Number',
        name: 'Ragic管理中心資料Id',
        noclone: true,
      },
      syncCenterAt: {
        type: 'Date',
        name: '上次同步管理中心時間',
      },
      syncStoreAt: {
        type: 'Date',
        name: '上次同步門市時間',
      },
    },
  },
  ui: {
    list: {
      columns: [
        { key: 'key', width: 100 },
        { key: 'name', width: 130 },
        { key: 'alias', width: 130 },
        { key: 'supplierName', width: 100 },
        { key: 'productCAT', width: 100 },
        { key: 'status', width: 100 },
        { key: 'supplyType', width: 100 },
        { key: 'ragicCenterNodeId', width: 100 },
        { key: 'ragicStoreNodeId', width: 100 },
      ],
    },
    editor: {
      config: { titleSm: 2, titleMd: 1 },
      groups: [
        {
          name: '供應商資料',
          rows: [
            [{ key: 'key' }],
            [{ key: 'name' }],
            [{ key: 'alias' }],
            [{ key: 'supplierName' }],
            [{ key: 'shortName' }],
            [{ key: 'owner' }],
            [{ key: 'CID' }],
            [{ key: 'contact' }],
            [{ key: 'phone' }],
            [{ key: 'phone2' }],
            [{ key: 'FAX' }],
            [{ key: 'address' }],
            [{ key: 'storageMA' }],
            [{ key: 'productCAT' }],
            [{ key: 'status' }],
            [{ key: 'supplyType' }],
            [{ key: 'paymentMethod' }],
            [{ key: 'netDays' }],
            [{ key: 'prepaidBalance' }],
            [{ key: 'isContractor' }],
            [{ key: 'note' }],
          ],
        },
      ],
    },
  },
}




// WEBPACK FOOTER //
// ./src/models/suppliers.js